module.exports = __webpack_public_path__ + "img/newton-2.a051763c.png";